var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"centen-bread-crumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_vm._l((_vm.route.matched),function(item,index){return [_c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.meta.name))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }